import { useCallback, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import confetti from "canvas-confetti";
import { useKonamiCode } from "@/hooks/useKonamiCode";
import { Trophy } from "lucide-react";

const EasterEggs = () => {
  const [showSecret, setShowSecret] = useState(false);

  const fireConfetti = useCallback(() => {
    const count = 200;
    const defaults = {
      origin: { y: 0.7 },
      colors: ["#E8533C", "#FF6B5B", "#FFD700", "#FFFFFF", "#1a1a1a"],
    };

    function fire(particleRatio: number, opts: confetti.Options) {
      confetti({
        ...defaults,
        ...opts,
        particleCount: Math.floor(count * particleRatio),
      });
    }

    fire(0.25, { spread: 26, startVelocity: 55 });
    fire(0.2, { spread: 60 });
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
    fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
    fire(0.1, { spread: 120, startVelocity: 45 });

    setShowSecret(true);
    setTimeout(() => setShowSecret(false), 3000);
  }, []);

  useKonamiCode(fireConfetti);

  return (
    <AnimatePresence>
      {showSecret && (
        <motion.div
          initial={{ opacity: 0, scale: 0.5, y: -100 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: -100 }}
          className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[100] bg-gradient-coral text-primary-foreground px-8 py-6 rounded-2xl shadow-2xl flex items-center gap-4"
        >
          <Trophy className="w-8 h-8 animate-bounce" />
          <span className="font-display text-2xl">🏆 CHAMPION MODE! 🏆</span>
          <Trophy className="w-8 h-8 animate-bounce" />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default EasterEggs;
